import React from 'react'
import MustHaveSkills from '../../components/MustHaveSkills'
import GoodToHaveSkills from '../../components/GoodToHaveSkills'


const JobDescription = ({ inputs, setInputs }: any) => {

	const handleOnChange = (input: string, value: any) => {
		setInputs((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
	};

	return (
		<div  >
			<div>
				<div style={{ width: "100%", marginTop: "20px" }}>
					<h6 className='employment-title-h6'>Qualifications</h6>

					<div className='AddJob_main_Description'>
						<div className='AddJob_main_Description_Top' style={{ height: "40%", }} >Enter job Qualification</div>
						<div style={{ height: "60%" }}>
							{/* @ts-ignore */}
							<textarea id="AddJob_main_Description_Inpout" rows="7" cols="150"
								value={inputs.qualifications}
								onChange={(e) => handleOnChange("qualifications", e.target.value)} />
						</div>
					</div>
				</div>
				<div style={{ width: "100%", marginTop: "20px" }}>
					<h6 className='employment-title-h6'>Job Role</h6>

					<div className='AddJob_main_Description'>
						<div className='AddJob_main_Description_Top' style={{ height: "40%", }} >Enter Job Role </div>
						<div style={{ height: "60%" }}>
							{/* @ts-ignore */}
							<textarea id="AddJob_main_Description_Inpout" rows="7" cols="150"
								value={inputs.jobRole}
								onChange={(e) => handleOnChange("jobRole", e.target.value)}
							/>
						</div>
					</div>
				</div>

				<div className='AddJob_main_container_input'>
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'>Must have skills</h6>

						<MustHaveSkills setInputs={setInputs} />
					</div>
					<div style={{ margin: '20px' }} />
					<div style={{ width: "100%" }}>
						<h6 className='employment-title-h6'>Good to have skills</h6>

						<GoodToHaveSkills setInputs={setInputs} />
					</div>
				</div>
				<div style={{ width: "100%", marginTop: "20px" }}>
					<h6 className='employment-title-h6'>Job Description</h6>

					<div className='AddJob_main_Description'>
						<div className='AddJob_main_Description_Top' style={{ height: "40%", }} >Enter Job Description </div>
						<div style={{ height: "60%" }}>
							{/* @ts-ignore */}
							<textarea id="AddJob_main_Description_Inpout" rows="10" cols="150"
								value={inputs.jobDescription}
								onChange={(e) => handleOnChange("jobDescription", e.target.value)} />
						</div>
					</div>
				</div>
			</div>
		</div >
	)
}

export default JobDescription